import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/store";
Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    // scroll top after route
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/Login.vue"),
    },
    {
      path: "/homepage",
      redirect: "/overview",
      component: () => import("../views/Home.vue"),
      children: [
        { path: "/overview", component: () => import("../views/Overview.vue") },
        {
          path: "/customanalysis",
          component: () => import("../views/CustomAnalysis.vue"),
        },
        { path: "/omg", component: () => import("../views/Photo.vue") },
        {
          path: "/taganalysis",
          component: () => import("../views/TagAnalysis.vue"),
        },
        {
          path: "/accountlist",
          component: () => import("../views/AccountList.vue"),
        },
      ],
    },
  ],
});

// login token check
router.beforeEach((to, from, next) => {
  const hasToken = document.cookie.includes("token");
  if (hasToken && to.path === "/login") {
    next("/homepage");
  } else if (!hasToken && to.path !== "/login") {
    next("/login");
    store.dispatch("resetAllData");
  } else {
    next();
  }
});
